export default function Logo() {
    return (
        <div className="h-full flex justify-center items-center">
            <img src="/assets/logo/logo.png" alt="FlexPrice Logo" className="p-3 h-14 bg-cover" />
        </div>
    )
}
